import { CLIENT_ID_QUERY_KEY } from '@/consts/const';
import { useFetch } from '@/hooks/useFetch';
import { useSearchQuery } from '@/hooks/useSearchQuery';
import type { ErrorResponse } from '@/types/apiTypes';
import type { CreateClientResponse } from '@/types/clientsApiTypes';
import { useMutation } from '@tanstack/react-query';

export type UseCreateClientMutationOptions = {
  onSuccess?: (response: CreateClientResponse) => void;
};

export const useCreateClientMutation = (options?: UseCreateClientMutationOptions) => {
  const [searchQuery] = useSearchQuery();
  const clientId = searchQuery.get(CLIENT_ID_QUERY_KEY);
  const { doFetch: createClient } = useFetch<unknown, CreateClientResponse>();

  const createClientMutation = useMutation<CreateClientResponse, ErrorResponse<unknown>, void>({
    mutationFn: () =>
      createClient('/api/clients/touch', {
        method: 'POST',
      }),
    onSuccess: (response) => {
      options?.onSuccess?.(response);
    },
  });

  return {
    ...createClientMutation,
    clientId,
  };
};
